module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1001.d004a9e4.png";